import { render, staticRenderFns } from "./AccountantSubscriptions.vue?vue&type=template&id=dd2d0622&"
import script from "./AccountantSubscriptions.vue?vue&type=script&lang=js&"
export * from "./AccountantSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./AccountantSubscriptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports